var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFsaLogoWithtext(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 273.83,
    height: 40.796,
    viewBox: "0 0 273.83 40.796",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 273.83,
    height: 40.796,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(-56.12 -243.132)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M107.575,244.044l14.392,8.267a.422.422,0,0,1,.21.364v17.173l2.642-1.5V250.991l-13.229-7.859-4.015.912Z",
    transform: "translate(-35.415 0)",
    fill: "#8e8881"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M117.436,296.573l2.664,1.552,14.964-8.773V273.874l-2.619-2.846v16.761a.422.422,0,0,1-.211.365l-14.8,8.419Z",
    transform: "translate(-42.202 -19.2)",
    fill: "#8e8881"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M77.667,336.058l15.014,8.579,13.379-7.52,1.309-4-14.427,8.459a.429.429,0,0,1-.423,0l-14.852-8.652v3.135Z",
    transform: "translate(-14.83 -61.8)",
    fill: "#8e8881"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(56.12 243.132)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M66.766,307.57l13.373,7.813,3.865-.8-14.467-8.267a.422.422,0,0,1-.211-.364V288.834L66.766,290.3V307.57Z",
    transform: "translate(-63.447 -274.587)",
    fill: "#8e8881"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M56,283.623l2.517,2.855V269.83a.421.421,0,0,1,.211-.364l14.865-8.487-2.656-1.525L56,268.016v15.608Z",
    transform: "translate(-56.037 -254.366)",
    fill: "#8e8881"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M71.787,250.023a.416.416,0,0,1,.21.056l14.695,8.441v-2.9l-14.9-8.56-13.183,7.6L57.236,258.3l14.343-8.221a.408.408,0,0,1,.209-.055Z",
    transform: "translate(-0.768 -2.707)",
    fill: "#8e8881"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M356.105,278.284c0-4.834-3.516-7.667-9.091-7.667h-11.47V294.7h5.29V284.62l9.237,10.077h7.038l-9.063-9.065c5.213-.177,8.059-2.643,8.059-7.348m-5.4,0c0,1.978-1.273,2.967-3.273,2.967h-6.6v-5.911h6.6c2,0,3.273,1.011,3.273,2.944",
    transform: "translate(-192.318 -18.917)",
    fill: "#f1192b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M356.105,278.284c0-4.834-3.516-7.667-9.091-7.667h-11.47V294.7h5.29V284.62l9.237,10.077h7.038l-9.063-9.065c5.213-.177,8.059-2.643,8.059-7.348m-5.4,0c0,1.978-1.273,2.967-3.273,2.967h-6.6v-5.911h6.6c2,0,3.273,1.011,3.273,2.944",
    transform: "translate(-192.318 -18.917)",
    fill: "none",
    stroke: "#f1192b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M356.105,278.284c0-4.834-3.516-7.667-9.091-7.667h-11.47V294.7h5.29V284.62l9.237,10.077h7.038l-9.063-9.065c5.213-.177,8.059-2.643,8.059-7.348Zm-5.4,0c0,1.978-1.273,2.967-3.273,2.967h-6.6v-5.911h6.6c2,0,3.273,1.011,3.273,2.944Z",
    transform: "translate(-192.318 -18.917)",
    fill: "#f1192b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M356.105,278.284c0-4.834-3.516-7.667-9.091-7.667h-11.47V294.7h5.29V284.62l9.237,10.077h7.038l-9.063-9.065c5.213-.177,8.059-2.643,8.059-7.348Zm-5.4,0c0,1.978-1.273,2.967-3.273,2.967h-6.6v-5.911h6.6c2,0,3.273,1.011,3.273,2.944Z",
    transform: "translate(-192.318 -18.917)",
    fill: "none",
    stroke: "#f1192b",
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M436.355,294.307a12.9,12.9,0,0,0,10.155-4.683l-4.1-3.088a7.607,7.607,0,0,1-6.073,2.875,7.53,7.53,0,1,1,0-15.06,7.617,7.617,0,0,1,6.007,2.791l4.035-3.155a12.9,12.9,0,0,0-10.027-4.55A12.482,12.482,0,0,0,423.5,281.891c0,6.982,5.577,12.415,12.854,12.415",
    transform: "translate(-252.856 -18.106)",
    fill: "#f1192b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M436.355,294.307a12.9,12.9,0,0,0,10.155-4.683l-4.1-3.088a7.607,7.607,0,0,1-6.073,2.875,7.53,7.53,0,1,1,0-15.06,7.617,7.617,0,0,1,6.007,2.791l4.035-3.155a12.9,12.9,0,0,0-10.027-4.55A12.482,12.482,0,0,0,423.5,281.891c0,6.982,5.577,12.415,12.854,12.415",
    transform: "translate(-252.856 -18.106)",
    fill: "none",
    stroke: "#f1192b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M436.355,294.307a12.9,12.9,0,0,0,10.155-4.683l-4.1-3.088a7.607,7.607,0,0,1-6.073,2.875,7.53,7.53,0,1,1,0-15.06,7.617,7.617,0,0,1,6.007,2.791l4.035-3.155a12.9,12.9,0,0,0-10.027-4.55A12.482,12.482,0,0,0,423.5,281.891c0,6.982,5.577,12.415,12.854,12.415Z",
    transform: "translate(-252.856 -18.106)",
    fill: "#f1192b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M436.355,294.307a12.9,12.9,0,0,0,10.155-4.683l-4.1-3.088a7.607,7.607,0,0,1-6.073,2.875,7.53,7.53,0,1,1,0-15.06,7.617,7.617,0,0,1,6.007,2.791l4.035-3.155a12.9,12.9,0,0,0-10.027-4.55A12.482,12.482,0,0,0,423.5,281.891c0,6.982,5.577,12.415,12.854,12.415Z",
    transform: "translate(-252.856 -18.106)",
    fill: "none",
    stroke: "#f1192b",
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M249.306,294.208a12.851,12.851,0,0,0,10.115-4.664l-4.08-3.077a7.577,7.577,0,0,1-6.05,2.864,7.5,7.5,0,1,1,0-15,7.585,7.585,0,0,1,5.983,2.78l4.019-3.143a12.852,12.852,0,0,0-9.988-4.532,12.432,12.432,0,0,0-12.8,12.4c0,6.954,5.554,12.366,12.8,12.366Z",
    transform: "translate(-124.151 -18.106)",
    fill: "#f1192b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M249.306,294.208a12.851,12.851,0,0,0,10.115-4.664l-4.08-3.077a7.577,7.577,0,0,1-6.05,2.864,7.5,7.5,0,1,1,0-15,7.585,7.585,0,0,1,5.983,2.78l4.019-3.143a12.852,12.852,0,0,0-9.988-4.532,12.432,12.432,0,0,0-12.8,12.4c0,6.954,5.554,12.366,12.8,12.366Z",
    transform: "translate(-124.151 -18.106)",
    fill: "none",
    stroke: "#f1192b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M249.306,294.208a12.851,12.851,0,0,0,10.115-4.664l-4.08-3.077a7.577,7.577,0,0,1-6.05,2.864,7.5,7.5,0,1,1,0-15,7.585,7.585,0,0,1,5.983,2.78l4.019-3.143a12.852,12.852,0,0,0-9.988-4.532,12.432,12.432,0,0,0-12.8,12.4c0,6.954,5.554,12.366,12.8,12.366Z",
    transform: "translate(-124.151 -18.106)",
    fill: "#f1192b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M249.306,294.208a12.851,12.851,0,0,0,10.115-4.664l-4.08-3.077a7.577,7.577,0,0,1-6.05,2.864,7.5,7.5,0,1,1,0-15,7.585,7.585,0,0,1,5.983,2.78l4.019-3.143a12.852,12.852,0,0,0-9.988-4.532,12.432,12.432,0,0,0-12.8,12.4c0,6.954,5.554,12.366,12.8,12.366Z",
    transform: "translate(-124.151 -18.106)",
    fill: "none",
    stroke: "#f1192b",
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M538.125,294.572h18.522v-1.988H540.272V282.561h12.2v-1.931l-12.2-.009v-8.063h16.365V270.6H538.125v23.973Z",
    transform: "translate(-331.747 -18.905)",
    fill: "#8e8881"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M538.125,294.572h18.522v-1.988H540.272V282.561h12.2v-1.931l-12.2-.009v-8.063h16.365V270.6H538.125v23.973Z",
    transform: "translate(-331.747 -18.905)",
    fill: "none",
    stroke: "#8e8881",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M538.125,294.572h18.522v-1.988H540.272V282.561h12.2v-1.931l-12.2-.009v-8.063h16.365V270.6H538.125v23.973Z",
    transform: "translate(-331.747 -18.905)",
    fill: "#8e8881"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M538.125,294.572h18.522v-1.988H540.272V282.561h12.2v-1.931l-12.2-.009v-8.063h16.365V270.6H538.125v23.973Z",
    transform: "translate(-331.747 -18.905)",
    fill: "none",
    stroke: "#8e8881",
    strokeWidth: 2.142
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M624.393,294.192,636.928,270.6h-2.333l-10.223,19.185L614.035,270.6H611.62l12.773,23.594Z",
    transform: "translate(-382.331 -18.904)",
    fill: "#8e8881"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M624.393,294.192,636.928,270.6h-2.333l-10.223,19.185L614.035,270.6H611.62l12.773,23.594Z",
    transform: "translate(-382.331 -18.904)",
    fill: "none",
    stroke: "#8e8881",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M624.393,294.192,636.928,270.6h-2.333l-10.223,19.185L614.035,270.6H611.62l12.773,23.594Z",
    transform: "translate(-382.331 -18.904)",
    fill: "#8e8881"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M624.393,294.192,636.928,270.6h-2.333l-10.223,19.185L614.035,270.6H611.62l12.773,23.594Z",
    transform: "translate(-382.331 -18.904)",
    fill: "none",
    stroke: "#8e8881",
    strokeWidth: 2.142
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M709.766,295.4,697.36,271.812,684.717,295.4h2.4l2.421-4.5h15.548l2.342,4.494Zm-5.652-6.348H690.5l6.838-13.063,6.775,13.063Z",
    transform: "translate(-432.641 -19.739)",
    fill: "#8e8881"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M709.766,295.4,697.36,271.812,684.717,295.4h2.4l2.421-4.5h15.548l2.342,4.494Zm-5.652-6.348H690.5l6.838-13.063,6.775,13.063Z",
    transform: "translate(-432.641 -19.739)",
    fill: "none",
    stroke: "#8e8881",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M709.766,295.4,697.36,271.812,684.717,295.4h2.4l2.421-4.5h15.548l2.342,4.494Zm-5.652-6.348H690.5l6.838-13.063,6.775,13.063Z",
    transform: "translate(-432.641 -19.739)",
    fill: "#8e8881"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M709.766,295.4,697.36,271.812,684.717,295.4h2.4l2.421-4.5h15.548l2.342,4.494Zm-5.652-6.348H690.5l6.838-13.063,6.775,13.063Z",
    transform: "translate(-432.641 -19.739)",
    fill: "none",
    stroke: "#8e8881",
    strokeWidth: 2.142
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M779.549,294.575h2.158V273.659l17.37,20.916h2.2V270.6h-2.148v20.971l-17.4-20.963h-2.183v23.968Z",
    transform: "translate(-497.911 -18.905)",
    fill: "#8e8881"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M779.549,294.575h2.158V273.659l17.37,20.916h2.2V270.6h-2.148v20.971l-17.4-20.963h-2.183v23.968Z",
    transform: "translate(-497.911 -18.905)",
    fill: "none",
    stroke: "#8e8881",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M779.549,294.575h2.158V273.659l17.37,20.916h2.2V270.6h-2.148v20.971l-17.4-20.963h-2.183v23.968Z",
    transform: "translate(-497.911 -18.905)",
    fill: "#8e8881"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M779.549,294.575h2.158V273.659l17.37,20.916h2.2V270.6h-2.148v20.971l-17.4-20.963h-2.183v23.968Z",
    transform: "translate(-497.911 -18.905)",
    fill: "none",
    stroke: "#8e8881",
    strokeWidth: 2.142
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M879.481,294.292c5.514-.028,9.408-2.538,9.376-6.533-.027-3.505-2.365-5.221-7.418-6.391l-3.487-.809c-3.923-.921-5.858-2.095-5.887-4.449-.033-2.73,2.811-4.224,6.934-4.3a14.526,14.526,0,0,1,7.911,2.277l1.121-1.691a17.32,17.32,0,0,0-9.211-2.556c-5.3.053-9.073,2.412-9.04,6.211.03,3.429,2.62,5.269,7.527,6.415l3.356.789c4.2.992,5.984,1.954,5.977,4.526-.005,2.857-2.937,4.485-7.076,4.537a18.887,18.887,0,0,1-9.733-2.582l-1.173,1.691a20.7,20.7,0,0,0,10.823,2.863Z",
    transform: "translate(-559.242 -18.383)",
    fill: "#8e8881"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(56.12 243.132)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M879.481,294.292c5.514-.028,9.408-2.538,9.376-6.533-.027-3.505-2.365-5.221-7.418-6.391l-3.487-.809c-3.923-.921-5.858-2.095-5.887-4.449-.033-2.73,2.811-4.224,6.934-4.3a14.526,14.526,0,0,1,7.911,2.277l1.121-1.691a17.32,17.32,0,0,0-9.211-2.556c-5.3.053-9.073,2.412-9.04,6.211.03,3.429,2.62,5.269,7.527,6.415l3.356.789c4.2.992,5.984,1.954,5.977,4.526-.005,2.857-2.937,4.485-7.076,4.537a18.887,18.887,0,0,1-9.733-2.582l-1.173,1.691a20.7,20.7,0,0,0,10.823,2.863Z",
    transform: "translate(-615.362 -261.515)",
    fill: "none",
    stroke: "#8e8881",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M879.481,294.292c5.514-.028,9.408-2.538,9.376-6.533-.027-3.505-2.365-5.221-7.418-6.391l-3.487-.809c-3.923-.921-5.858-2.095-5.887-4.449-.033-2.73,2.811-4.224,6.934-4.3a14.526,14.526,0,0,1,7.911,2.277l1.121-1.691a17.32,17.32,0,0,0-9.211-2.556c-5.3.053-9.073,2.412-9.04,6.211.03,3.429,2.62,5.269,7.527,6.415l3.356.789c4.2.992,5.984,1.954,5.977,4.526-.005,2.857-2.937,4.485-7.076,4.537a18.887,18.887,0,0,1-9.733-2.582l-1.173,1.691a20.7,20.7,0,0,0,10.823,2.863Z",
    transform: "translate(-559.242 -18.383)",
    fill: "#8e8881"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(56.12 243.132)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M879.481,294.292c5.514-.028,9.408-2.538,9.376-6.533-.027-3.505-2.365-5.221-7.418-6.391l-3.487-.809c-3.923-.921-5.858-2.095-5.887-4.449-.033-2.73,2.811-4.224,6.934-4.3a14.526,14.526,0,0,1,7.911,2.277l1.121-1.691a17.32,17.32,0,0,0-9.211-2.556c-5.3.053-9.073,2.412-9.04,6.211.03,3.429,2.62,5.269,7.527,6.415l3.356.789c4.2.992,5.984,1.954,5.977,4.526-.005,2.857-2.937,4.485-7.076,4.537a18.887,18.887,0,0,1-9.733-2.582l-1.173,1.691a20.7,20.7,0,0,0,10.823,2.863Z",
    transform: "translate(-615.362 -261.515)",
    fill: "none",
    stroke: "#8e8881",
    strokeWidth: 2.142
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFsaLogoWithtext);
export default __webpack_public_path__ + "static/media/fsa_logo_withtext.91bf30da996e451919f81563804ca738.svg";
export { ForwardRef as ReactComponent };